import React, { Component } from 'react';
import Steps from '../../../components/Steps/Steps';
import {uploadEmployeeDataSteps} from './../../../utils/constants';

const withStep = (WrappedComponent,step) => {
  // ...and returns another component...
  return class extends Component {
    render() {
      return (
        <div className="">
          <div className="title-text">
            Import from a File
          </div>
          <Steps
            steps={uploadEmployeeDataSteps}
            currentStep={step}
          />
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  };
}

export default withStep;